import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl} from "@angular/forms";
import { NotifierService } from 'angular-notifier';
import { faPlus, faTimes, faSave, faArrowRight, faClock} from '@fortawesome/free-solid-svg-icons';
import { CryptoService } from '@bt/core/services/crypto.service';
import { BaseComponent } from '@bt/core/base/base.component';
import { CurrentBalanceModel } from '@bt/core/models/currentBalanceModel.mode';
import { Withdrawal } from '@bt/core/models/withdraw.model';
import { WithdrawalService } from '@bt/core/services/withdrawal.service';
import { WithdrawalStatus } from '@bt/core/constants/withdrawal.status';
import { environment } from "@src/environments/environment";
import { validateWalletAddress } from "@bt/withdraw/walletAddressValidator";

@Component({
  selector: 'app-withdraw',
  templateUrl: './withdraw.component.html',
  styleUrls: ['./withdraw.component.scss']
})
export class WithdrawComponent extends BaseComponent implements OnInit {

  faTimes = faTimes;
  faSave = faSave;
  faPlus = faPlus;
  faArrowRight = faArrowRight;
  faClock = faClock;

  public newtworkMode: string;
  public withdrawForm: FormGroup;
  public options: any[] = [];
  public wallets: CurrentBalanceModel[] = [];
  public config: any;
  public isModalOpened: boolean;
  public hasInfo: boolean = true;
  public selected: CurrentBalanceModel = new CurrentBalanceModel();
  public requested: boolean = false;
  public newWithdrawal: Withdrawal;
  public withdrawals: Withdrawal[] = [];
  public isExitsBlocked : boolean = true;
  private loadTick :any;
  get wallet() { return this.withdrawForm.get('wallet')}
  get address() { return this.withdrawForm.get('address')}
  get sum() { return this.withdrawForm.get('sum')}
  get code1() { return this.withdrawForm.get('code1')}
  get code2() { return this.withdrawForm.get('code2')}
  public isSwap: boolean = false;

  constructor(
    private notifierService: NotifierService,
    private formBulider: FormBuilder,
    private cryptoService: CryptoService,
    private withdrawService: WithdrawalService) {
      super();
      this.newtworkMode = environment.networkType;
    }

  ngOnInit() {
    var t= this;
    this.loadWallets()
    .then(() =>{
      this.selected = this.wallets.find(x => x.walletType == 'BTC');
      this.withdrawForm = this.formBulider.group({
        wallet: ["", [Validators.required]],
        address: ["", [Validators.required,
                
                  (control: AbstractControl) => this.ValidatorWalletDuplicate.bind(this)(control)]],
        sum: ["", [Validators.required,
                  (control: AbstractControl) => Validators.min(+this.selected.minSum)(control),
                  (control: AbstractControl) => Validators.max(+this.selected.availableSum)(control),
                  Validators.pattern(this.floatPattern)]],
        code1: ["", [Validators.required, Validators.minLength(5), Validators.pattern(this.integerPattern), Validators.maxLength(5)]],
        code2:  ["", [Validators.required, Validators.minLength(5), Validators.pattern(this.integerPattern), , Validators.maxLength(5)]]
      });
      this.wallet.setValue('BTC')
    })
    .catch((error) => {
      this.notifierService.notify('error', "Не удалось получить список валют")
    });

    this.loadWithdrawals()
    setStyle();
    t.loadIsExitsBlocked();

    this.config = {
      labelField: 'label',
      valueField: 'label',
      searchField: 'label',
      highlight: false,
      create:false,
      persist:true,
      dropdownDirection: 'down',
     // maxItems: 1,
      sum: "sum",
      render: {
        option: function(item, escape) {

          return '<div class="option">' +
            '<img src="../../assets/img/crypto/'+item.label+'.png" alt="'+escape(item.label)+'" height="20" width="20">' +
            '<span style="margin-left:  5px; ">'+escape(item.label)+'</span>' +
            '</div>';
        },
        item: function(item, escape) {

          return '<div class="item">'+
          '<img src="../../assets/img/crypto/'+item.label+'.png" alt="'+escape(item.label)+'" height="20" width="20">'+
          '<span style="margin-left:  5px; ">'+escape(item.label)+'</span>' +
          '</div>';
        }
      }
    };

    function setStyle() {
      if ((<any>window).$(".my-selectize-input .selectize-control .selectize-input").val() != undefined) {
        var t = (<any>window).$(".my-selectize-input .selectize-control .selectize-input");
        t.css({
          'width': '100%',
          'padding': '6px 0px 0px 15px',
          'margin': '0',
          'background': 'inherit',
          'color': 'black',
          'border': 'none',
          'border-bottom': '1px solid',
          'line-height': '19px',
          'margin-bottom': '15px'
        });
      }
      else {
        setTimeout(setStyle, 100);
      }
    }

    t.loadTick = setInterval(function(){
      t.loadIsExitsBlocked(false);
      t.loadWithdrawals(false);

    },20000);
  }

  ngOnDestroy() {
    clearInterval(this.loadTick);
  }

  /**Закрыть или открыть модальное окно*/
  public actModal(open: boolean):void{
    this.loadWithdrawals();
    this.loadIsExitsBlocked(false);
    this.isModalOpened = open;
    this.loadWallets().then(() => {
      this.requested = false;
      this.isSwap = false;
      this.address.enable();
      this.sum.enable();
      this.withdrawForm.markAsUntouched();
    })

    if(open){
      (<any>window).$(".bitmap").removeClass("has-scroll");
    }
    else{
      this.resetForm(this.withdrawForm);
      (<any>window).$(".bitmap").addClass("has-scroll");
    }
  }

    /**Очистить форму*/
  public resetForm(form: FormGroup){
    form.controls['address'].setValue("")
    form.controls['sum'].setValue("")
    form.controls['code1'].setValue("")
    form.controls['code2'].setValue("")
  }

  /**Проверить и отправить запрос на вывод*/
  public requestWithdraw(): void{
    this.markAsUsed([this.sum, this.address])
    if(this.validateRequest()){
      this.sendRequest();
    }
  }

  clickSwap() {
    const t = this;
    t.isSwap = !t.isSwap;
    t.address.updateValueAndValidity();
  }


  /**Отправить запрос на вывод*/
  public sendRequest(): void{
    const t = this;
    t.newWithdrawal = new Withdrawal(t.address.value, +t.sum.value.replace(",","."), t.wallet.value, Date.now());
    t.setLoading(true);

    if (t.isSwap){
      t.newWithdrawal.swapInTokenType = "USDT";
    }

    t.withdrawService.createWithdrawalAsync(t.newWithdrawal)
    .then((resp) => {
      t.setLoading(false);
      if(resp.data != 0){
        //this.requested = true;
        t.actModal(false)
        // this.newWithdrawal.id = resp.data;
        // this.notifierService.notify("success", "Введите коды подтверждения");
      }
    })
    .catch((err) => {
      t.setLoading(false);
      if(err.error!=undefined && err.error.errorMsgs!=undefined)
        t.notifierService.notify("error", err.error.errorMsgs[0]);
      else
        t.notifierService.notify("error", "Ошибка");
    })
  }

   /**Отправить коды и подтвердить вывод*/
  public sendCodes(): void{
    this.setLoading(true);
    this.withdrawService.confirmWithdrawlAsync(this.newWithdrawal)
    .then((resp) => {
      if(resp.data){
        this.notifierService.notify("success", "Подтверждено");
        this.actModal(false)
      }
      else{
        this.notifierService.notify("error", resp.errorMsgs[0]);
      }
      this.setLoading(false);
    })
    .catch((err) => {
      this.setLoading(false);
      this.notifierService.notify("error", "Не удалось подтвердить вывод");
    })
  }

   /**Проверить корректность запроса*/
  public validateRequest(): boolean{
    if(this.address.invalid || this.sum.invalid){
      this.notifierService.notify("error", "Некорректный запрос");
      return false;
    }
    this.address.disable()
    this.sum.disable()
    return true;
  }

  /**Проверить корректность кодов*/
  public validateCodes(): boolean {
    if (this.code1.invalid || this.code2.invalid) {
        this.notifierService.notify("error", "Неправильные коды");
        return false;
      }
    return true;
  }

  /**Загрузить доступные валюты*/
  public loadWallets(): any{
    this.setLoading(true);
    let promise = this.cryptoService.getAllCurrentBalances();
    promise
      .then((resp)=>{
       resp.data.forEach(w => this.options.push({label: w.walletType}));
       this.wallets = resp.data;
       this.setLoading(false);
      })
      .catch((error) => {
        this.setLoading(false);
        this.notifierService.notify('error',  "Не удалось получить список валют")
      });

      return promise;
  }


   /**Загрузить все выводы*/
  public loadWithdrawals(isUseLoading = true): void{
    this.setLoading(isUseLoading);
    this.withdrawService.getAllWithdrawalsAsync()
    .then((resp) => {
      this.hasInfo = resp.data.length > 0;
      if(resp.data != null && resp.data.length > 0){
        this.withdrawals = resp.data;
        this.withdrawals.forEach(w => {
          w.stringDate = this.getStringDate(w.date)
          w.stringStatus = WithdrawalStatus.getStringStatus(w.status)
        })
      }
      this.setLoading(false);
    })
    .catch((err) => {
      this.notifierService.notify("error", "Не удалось загрузить строки таблицы");
      this.setLoading(false);
    })

  }

    /**Загрузить все выводы*/
    public loadIsExitsBlocked(isUseLoading = true): void{
      this.setLoading(isUseLoading);
      this.withdrawService.isExitsBlocked()
      .then((resp) => {
        this.isExitsBlocked = resp.data;

        this.setLoading(false);
      })
      .catch((err) => {
        this.notifierService.notify("error", "Не удалось загрузить данные");
        this.setLoading(false);
      })

    }

  public onChange(event): void{
   this.selected = this.wallets.find(x => x.walletType == event)
   this.address.updateValueAndValidity()
   this.sum.updateValueAndValidity()
  }

   /**Получить форматированную дату*/
  public getStringDate(date: any): string{
    let d = new Date(date)
    let dd = d.getDate() >= 10 ? d.getDate() : `0${d.getDate()}`
    let MM = d.getMonth() >= 10 ? d.getMonth()+1 : `0${d.getMonth() + 1}`
    let yyyy = d.getFullYear();

    let hh =  d.getHours() >= 10 ? d.getHours() : `0${d.getHours()}`
    let mm =  d.getMinutes() >= 10 ? d.getMinutes() : `0${d.getMinutes()}`
    return `${dd}.${MM}.${yyyy} ${hh}:${mm}`;
  }

   /**Валидатор адреса валюты*/
  ValidatorCoinAddress(control: AbstractControl): { [s: string]: any } {

      return null;

  }

    /**Валидатор вывода на дрес хранилища*/
    ValidatorWalletDuplicate(control: AbstractControl): {[s:string]:any}{
      try {
        const adrsInvalid = this.selected.walletAddress == this.address.value;
        if(adrsInvalid){
          return {
            "address": true,
            "text" : "Нельзя совершить вывод на адрес хранилища"
          };
        }
      } catch (error) {
        return null;
      }
    }

  /**Пользователь использовал форму*/
  public markAsUsed(controls: AbstractControl[]){
    for (let control of controls) {
        control.markAsDirty();
      if (Object.prototype.hasOwnProperty.call(control, 'touched')) {
         control.markAsTouched();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/withdraw/withdraw.component.ts